import React from 'react';
import { Trophy } from 'lucide-react';

export default function FantasyFootballCallToAction() {
  const scrollToGenerator = () => {
    document.getElementById('fantasy-football-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="py-20 bg-green-600">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-6">
          <Trophy className="w-12 h-12 text-green-200" />
        </div>
        <h2 className="text-3xl font-bold text-white mb-4">
          Ready to Name Your Fantasy Football Team?
        </h2>
        <p className="text-xl text-green-100 mb-8">
          Join thousands of fantasy managers who've found their perfect team name with our specialized generator.
        </p>
        <button 
          onClick={scrollToGenerator}
          className="bg-white text-green-600 text-lg px-8 py-4 rounded-lg hover:bg-green-50 transition-colors cursor-pointer shadow-lg hover:shadow-xl"
        >
          Create Your Team Name Now!
        </button>
        <p className="mt-6 text-sm text-green-200">
          Perfect for casual leagues, competitive managers, and championship contenders
        </p>
      </div>
    </section>
  );
}